import HomeApi from '@api/home'
import {
  EDIT_WEDDING_HALL_PATH_A,
  HOTEL_MENU_CREATE_PATH_A,
  UNIQUE_INFO_PATH_A
} from '@components/Hotel/constant'
import {
  DECORATION_BACKGROUND,
  DECORATION_PATH_A,
  DYNAMIC_PATH_A,
  EDIT_STORE_PATH_A,
  GROUP_MEMBER_PATH_A,
  GROUP_SETTING_PATH_A,
  PUBLISH_CASE_PATH_A,
  PUBLISH_MEAL_PATH_A,
  PUBLISH_STYLE_PATH_A,
  SCHEDULETOOL_PATH_A,
  SHOP_PRODUCTS_PATH_A,
  SI_YI_TEAM_GROUP_MEMBER_PATH_A
} from '@constant'
import { HLJ_MERCHANT_MY_COUNT } from '@merchant-backend/common-components/src/Head/constant'
import { isSiDaProperty } from '@merchant-backend/util'
import { isHotelMerchant, getJti, isSiYiTeam } from '@util'

export default () => {
  return {
    decoration: {
      // 完善店铺简介
      path:
        !isHotelMerchant() && !isSiDaProperty()
          ? `${DECORATION_PATH_A}?type=${DECORATION_BACKGROUND}`
          : EDIT_STORE_PATH_A,
      icon: ''
    },
    bindWechat: {
      // 绑定微信
      // path: SELLERSERVICE_PATH_A,
      path: HLJ_MERCHANT_MY_COUNT + getJti(),
      icon: ''
    },
    package: {
      // 发布套餐
      path: PUBLISH_MEAL_PATH_A,
      icon: ''
    },
    case: {
      // 发布案例
      path: PUBLISH_CASE_PATH_A,
      icon: ''
    },
    style: {
      // 发布款式
      path: PUBLISH_STYLE_PATH_A,
      icon: ''
    },
    dynamic: {
      // 发布动态
      path: DYNAMIC_PATH_A,
      icon: ''
    },
    menu: {
      // 发布菜单
      path: HOTEL_MENU_CREATE_PATH_A,
      icon: ''
    },
    hall: {
      // 发布场地
      path: EDIT_WEDDING_HALL_PATH_A,
      icon: ''
    },
    feature: {
      // 设置酒店特色
      path: UNIQUE_INFO_PATH_A,
      icon: ''
    },
    calender: {
      // 创建档期
      path: SCHEDULETOOL_PATH_A,
      icon: ''
    },
    group_ultimate: {
      path: SHOP_PRODUCTS_PATH_A
    },
    activated: {
      // 购买团队旗舰版
      path: SHOP_PRODUCTS_PATH_A
    },
    group_authority: {
      // 设置团队权限
      path: GROUP_SETTING_PATH_A,
      extra: async () => {
        await HomeApi.fourRoleGroupSetting()
      }
    },
    create_members_or_set_meals: {
      // 创建成员/套餐
      path: isSiYiTeam() ? SI_YI_TEAM_GROUP_MEMBER_PATH_A : GROUP_MEMBER_PATH_A
    },
    package_on: {
      // 上架套餐（服务&价格）
      path: PUBLISH_MEAL_PATH_A
    }
  }
}
